// extracted by mini-css-extract-plugin
export default {"container":"Media_container__-Ov0R","header":"Media_header__melOJ","subheader":"Media_subheader__2pvdP","card":"Media_card__t9kJ+"};